module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jaoa.categories), function(category) {
    return _c('option', [_vm._v(_vm._s(category))])
  }), 0)]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showImageForm) ? _c('div', {
    staticClass: "image-group",
    attrs: {
      "id": "imageGroup"
    }
  }, [_c('h3', [_vm._v("Image")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "imageSrc"
    }
  }, [_vm._v("Image URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageSrc),
      expression: "imageSrc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "imageSrc",
      "onFocus": "this.select();"
    },
    domProps: {
      "value": (_vm.imageSrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageSrc = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("Image size: 480px x 240px")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "imageUrl"
    }
  }, [_vm._v("Image Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "imageUrl"
    },
    domProps: {
      "value": (_vm.imageUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageUrl = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "imageAlt"
    }
  }, [_vm._v("Alt Text")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageAlt),
      expression: "imageAlt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "imageAlt"
    },
    domProps: {
      "value": (_vm.imageAlt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageAlt = $event.target.value
      }
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "authors"
    }
  }, [_vm._v("Authors")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authors),
      expression: "authors"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "authors"
    },
    domProps: {
      "value": (_vm.authors)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authors = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "blurb"
    }
  }, [_vm._v("Blurb")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blurb),
      expression: "blurb"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "blurb",
      "row": "4"
    },
    domProps: {
      "value": (_vm.blurb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.blurb = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "url"
    }
  }, [_vm._v("Article Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleUrl),
      expression: "articleUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "url"
    },
    domProps: {
      "value": (_vm.articleUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.articleUrl = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "for": "articleType"
    }
  }, [_vm._v("Component Type")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.series),
      expression: "series"
    }],
    staticClass: "form-control",
    staticStyle: {
      "display": "inline-block",
      "width": "50%"
    },
    attrs: {
      "id": "articleType",
      "name": "series"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.series = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jaoa.articleTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0), _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "id": "showImageForm"
    },
    domProps: {
      "textContent": _vm._s(_vm.showImageForm ? 'Remove Image' : 'Add Image')
    },
    on: {
      "click": function($event) {
        _vm.showImageForm = !_vm.showImageForm
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video),
      expression: "video"
    }],
    attrs: {
      "type": "checkbox",
      "name": "video"
    },
    domProps: {
      "checked": Array.isArray(_vm.video) ? _vm._i(_vm.video, null) > -1 : (_vm.video)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.video,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.video = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.video = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.video = $$c
        }
      }
    }
  }), _vm._v(" Video\n")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.free),
      expression: "free"
    }],
    attrs: {
      "type": "checkbox",
      "name": "free"
    },
    domProps: {
      "checked": Array.isArray(_vm.free) ? _vm._i(_vm.free, null) > -1 : (_vm.free)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.free = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.free = $$c
        }
      }
    }
  }), _vm._v(" Free \n")])])]), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")]), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "copyTextVersion",
      "data-component": _vm.currentTemplate,
      "aria-label": "Copied Text!"
    },
    on: {
      "click": _vm.copyTextVersion
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy text")])])])], 1), _c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "slot": "render",
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    },
    slot: "render"
  }, [_c('tr', [_c('td', {
    class: _vm.className,
    style: (_vm.paddingStyleRootTd),
    attrs: {
      "align": "center",
      "bgcolor": "#ffffff"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "520"
    }
  }, [(_vm.series == 'series-first' || !_vm.series) ? _c('tr', [_c('td', {
    attrs: {
      "bgcolor": _vm.jaoa.categoryColors[_vm.category].full
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "section-title",
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "480"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 25px 10px 25px",
      "font-size": "0"
    }
  })]), _c('tr', [_c('td', {
    style: ({
      borderTop: '4px solid' + _vm.jaoa.categoryColors[_vm.category].tint,
      fontSize: 0
    }),
    attrs: {
      "width": "100%"
    }
  })]), _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "padding": "5px 0px 6px 0px",
      "font-family": "'Raleway', Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "20px",
      "line-height": "24px",
      "text-transform": "uppercase",
      "color": "#ffffff"
    }
  }, [_vm._v(_vm._s(_vm.category))])])])])])])])]) : _vm._e(), _c('tr', [_c('td', [_c('table', {
    staticClass: "wrapper",
    style: (_vm.tableStyle),
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%",
      "align": "center"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showImageForm) ? _c('tr', [_c('td', {
    staticClass: "padding-feature-image",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "5px",
      "padding-left": "0",
      "padding-right": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "480",
      "align": "center"
    }
  }, [_c('tr', [_c('td', [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.imageUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "fluid-image",
    staticStyle: {
      "display": "block",
      "padding": "0",
      "color": "#ffffff",
      "font-family": "Helvetica, arial, sans-serif",
      "font-size": "16px"
    },
    attrs: {
      "src": _vm.imageSrc,
      "width": "480",
      "height": "240",
      "border": "0",
      "alt": _vm.imageAlt
    }
  })])])])])])]) : _vm._e()]), _c('tr', [_c('td', {
    staticClass: "padding-no-bottom",
    style: (_vm.paddingStyleBody),
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "480",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 20px 0px"
    }
  }, [_c('a', {
    staticClass: "body-text",
    style: ({
      textDecoration: 'none',
      fontFamily: "'Raleway', Helvetica, arial, sans-serif",
      fontWeight: 500,
      fontSize: '22px',
      lineHeight: '28px',
      color: _vm.jaoa.categoryColors[_vm.category].full
    }),
    attrs: {
      "href": _vm.articleUrl,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + "  "), (_vm.video) ? _c('span', {
    staticStyle: {
      "padding": "3px 9px 3px 9px",
      "vertical-align": "bottom",
      "font-family": "Helvetica, Arial, sans-serif",
      "font-weight": "normal",
      "font-size": "13px",
      "line-height": "28px",
      "letter-spacing": ".5px",
      "background-color": "#FDE9E6",
      "color": "#f26046"
    }
  }, [_vm._v(" VIDEO ")]) : _vm._e(), (_vm.video && _vm.free) ? _c('span', [_vm._v(" ")]) : _vm._e(), (_vm.free) ? _c('span', {
    staticStyle: {
      "padding": "3px 9px 3px 9px",
      "vertical-align": "bottom",
      "font-family": "Helvetica, Arial, sans-serif",
      "font-weight": "normal",
      "font-size": "13px",
      "line-height": "28px",
      "letter-spacing": ".5px",
      "background-color": "#E8F1FA",
      "color": "#4e98da"
    }
  }, [_vm._v(" FREE ")]) : _vm._e()])])]), (_vm.authors) ? _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "padding": "0px 0px 20px 0px",
      "font-family": "'Roboto', Helvetica, Arial, sans-serif",
      "font-weight": "normal",
      "font-size": "14px",
      "text-align": "left",
      "line-height": "18px",
      "color": "#909090"
    }
  }, [_vm._v(_vm._s(_vm.authors))])]) : _vm._e(), (_vm.blurb) ? _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "padding": "0px 0px 25px 0px",
      "font-family": "'Roboto', Helvetica, Arial, sans-serif",
      "font-weight": "normal",
      "font-size": "16px",
      "text-align": "left",
      "line-height": "20px",
      "color": "#666666"
    }
  }, [_vm._v(_vm._s(_vm.blurb))])]) : _vm._e()])])]), (_vm.series && _vm.series !== 'series-last') ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 0px 0px",
      "border-bottom": "1px solid #cccccc",
      "font-size": "0"
    }
  })]) : _vm._e(), (_vm.series && _vm.series !== 'series-last') ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 0px 0px",
      "font-size": "0"
    }
  })]) : _vm._e()], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0981946a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jaoa/article.vue
// module id = 212
// module chunks = 0